export const PAGE_MODE = {
  VIP_ADMIN: 1,
  ISACA_APPRAISER_ATL: 2,
  ATM: 3,
  ORG: 4,
  ORG_UNIT: 5,
  ORG_ATM: 6,
  ORG_UNIT_ATM: 7,
  TBD: 8,
  ATL_OBSERVER: 9,
  ASSIGNED_ATL_OBSERVER: 10
};
